<template>
  <div class="about bg-info bg-gradient text-dark">
    <h1>This is an about page</h1>
    <h4 class="display-2">This is the about page</h4>
    <p class="badge bg-dark text-white">{{ $store.getters.getName }}</p>
  </div>
</template>
